import { useQuery } from '@tanstack/react-query'
import { fetchCompanyOverviewEmployeesData } from 'services/verticalsApi'
import { Employee } from './types'
import { Filter } from 'components/FilterDrawer/FilterDrawer.config'

interface useEmployeesQueryProps {
  caseId: string
  zoneActivityIndices: string | null
  pageSize: number
  searchValue: string
  filters: Filter[]
  sort?: string | qs.ParsedQs | string[] | qs.ParsedQs[]
  page: number
}

export const useEmployeesQuery = ({
  caseId,
  zoneActivityIndices,
  pageSize,
  searchValue,
  filters,
  sort,
  page,
}: useEmployeesQueryProps) => {
  const { data, isFetching, isLoading } = useQuery<{ total: number; items: Employee[] } | null>({
    queryKey: ['employees', caseId, zoneActivityIndices, pageSize, searchValue, filters, page, sort],
    queryFn: async ({ signal }) => {
      if (!zoneActivityIndices) return null
      const fromIndex = page * pageSize
      return await fetchCompanyOverviewEmployeesData(
        caseId,
        fromIndex,
        zoneActivityIndices,
        searchValue,
        filters,
        pageSize,
        signal,
      )
    },
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  })

  return {
    verticalDocumentActivity: data?.items ?? null,
    isFetching,
    isLoading,
    total: data?.total ?? 0,
  }
}
